import InstructorResourceTab from './instructor-resource-tab';

export default InstructorResourceTab;
